<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <a-form-model layout="inline" :model="searchForm.data">
          <a-form-model-item label="年份">
            <a-select v-model="searchForm.data.year" @change="getSellPlansList">
              <a-select-option title="2020" value="2020">2020</a-select-option>
              <a-select-option title="2021" value="2021">2021</a-select-option>
              <a-select-option title="2022" value="2022">2022</a-select-option>
              <a-select-option title="2023" value="2023">2023</a-select-option>
              <a-select-option title="2024" value="2024">2024</a-select-option>
              <a-select-option title="2025" value="2025">2025</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </div>
      <div>
        <yearly-calendar :year="searchForm.data.year">
          <template v-slot:default="slotProps">
            <div
              @click="showDailyPlan(slotProps.day)"
                 :class="[calendar.days.includes(slotProps.day.dateString)?'active-day':'']">
              {{ slotProps.day.day }}
            </div>
          </template>
        </yearly-calendar>
      </div>
    </div>
    <a-drawer
      width="50%"
      :close-on-click-modal="false"
      title="预售计划"
      :visible="dailyView.visible"
      @close="getSellPlansList">
      <sell-plan-daily-view v-if="dailyView.visible" :day="dailyView.data.day"/>
    </a-drawer>
  </a-card>
</template>

<script>
import moment from 'moment';
import {
  _querySellPlans,
  _deleteSellPlan,
} from '@/api/sellPlanApi';
import YearlyCalendar from '@/components/YearlyCalendar.vue';
import SellPlanDailyView from './SellPlanDailyView.vue';
import SellPlanEdit from './SellPlanEdit.vue';

async function getSellPlansList() {
  this.dailyView.visible = false;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _querySellPlans({
    startAt: `${this.searchForm.data.year}-01-01 00:00:00`,
    endAt: `${this.searchForm.data.year}-12-31 23:59:59`,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  const daySet = new Set();
  this.table.data.forEach((x) => {
    daySet.add(moment(x.sellStartAt)
      .format('YYYY-MM-DD'));
  });
  this.calendar.days = [...daySet];
  this.table.query.total = result.totalElements;
}

function editSku(sellPlanId) {
  // this.skuForm.data.id = sellPlanId;
  // this.skuForm.visible = true;
  this.$router.push(`/sellPlan/${sellPlanId}/sku`);
}

function addSellPlans() {
  this.$router.push('/sellPlan-add');
}

function editSellPlans(sellPlanId) {
  // this.form.data.id = sellPlanId;
  // this.form.visible = true;
  this.$router.push(`/sellPlan/${sellPlanId}`);
}

function showDailyPlan(day) {
  this.dailyView.data.day = day.dateString;
  this.dailyView.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getSellPlansList();
}

async function deleteSellPlans(sellPlanId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteSellPlan(sellPlanId);
      this.$message.success('删除成功');
      this.getSellPlansList();
    },
  });
}

function handleSizeChange(val) {
  this.table.query.size = val;
  this.getSellPlansList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getSellPlansList();
}

export default {
  name: 'SellPlansList',
  components: {

    SellPlanDailyView,
    YearlyCalendar,
  },
  data() {
    return {
      dailyView: {
        visible: false,
        data: {
          day: '',
        },
      },
      searchForm: {
        data: {
          year: moment()
            .format('YYYY'),
          name: '',
          categoryId: '',
          brandId: '',
          seriesId: '',
          memberOnly: '',
        },
      },
      calendar: {
        days: [],
      },
      skuForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 20,
          total: 0,
        },
        sort: {
          prop: 'updateAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getSellPlansList,
    showDailyPlan,
    deleteSellPlans,
    editSellPlans,
    addSellPlans,
    closeForm,
    editSku,
    handleSizeChange,
    handlePageChange,
  },
  async created() {
    this.getSellPlansList();
  },
};
</script>

<style>
.active-day {
  background: #000000;
  color: #ffffff;
}

.calendar-other-month .day .active-day {
  color: #c1c0c0 !important;
  background: none;
}
</style>
